import Vue from 'vue';

const EventBus = new Vue();

export default EventBus;

export enum Event {
  BUSINESS_UNIT_SELECTED = 'business-unit-selected',
  BILLING_SIMULATED = 'BILLING_SIMULATED',
  BILLING_PERFORMED = 'BILLING_PERFORMED',
}
